import { render, staticRenderFns } from "./Tab.vue?vue&type=template&id=33d21030"
import script from "./Tab.vue?vue&type=script&lang=js"
export * from "./Tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports